import styled from 'styled-components';

export const SectionAnchor = styled.section`
    position: relative;
    width: 100%;
    scroll-margin-top: 16px;
`;
